<form
    [formGroup]="paymentForm"
    (ngSubmit)="onSubmit(paymentForm.value)"
    *ngIf="paymentSent === false"
>
    <fieldset>
        <span style="font-size: smaller; font-weight: bolder">
            Important information to know before purchasing a credential verification:
            <br>
        </span>
        <ul style="font-size: smaller">
            <li>
                The credential verification letter will be emailed to address entered below.
            </li>
            <li>
                You are requesting the credential verification letter for {{practitionerName}}.
            </li>
            <li>
                Refunds are not issued for credential verification payments.
            </li>
        </ul>
        <legend>Payment Information</legend>
        <div class="nested-fields">
            <!-- <div class="field">
        <div class="field__label-input-wrap">
          <label for="quantity" class="label">Qty</label>
          <input
  class="input input--small"
  [class.input--invalid]="formErrors.quantity"
  formControlName="quantity"
  id="quantity"
  name="quantity"
  mask="0*"
/>
          <div
            *ngIf="formErrors.quantity"
            class="error-message field__error-message"
          >
            {{ formErrors.quantity }}
          </div>
        </div>
      </div> -->
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="email"
                        class="label"
                    >
                        Email
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.email"
                        id="email"
                        formControlName="email"
                        maxlength="75"
                    >
                    <div
                        *ngIf="formErrors.email"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.email }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="company"
                        class="label"
                    >
                        Company
                        <span class="label__help-text">(optional)</span>
                    </label>
                    <input
                        class="input"
                        [class.input--invalid]="formErrors.company"
                        id="company"
                        formControlName="company"
                        maxlength="50"
                    >
                    <div
                        *ngIf="formErrors.company"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.company }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item form-row__item--medium">
                    <div class="field__label-input-wrap">
                        <label
                            for="firstName"
                            class="label"
                        >
                            First Name
                        </label>
                        <div class="field__label-input-wrap">
                            <input
                                class="input"
                                [class.input--invalid]="formErrors.firstName"
                                id="firstName"
                                formControlName="firstName"
                                maxlength="35"
                            >
                            <div
                                *ngIf="formErrors.firstName"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.firstName }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="lastName"
                            class="label"
                        >
                            Last Name
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.lastName"
                            id="lastName"
                            formControlName="lastName"
                            maxlength="35"
                        >
                        <div
                            *ngIf="formErrors.lastName"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.lastName }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="field form-row__item form-row__item--medium">
                    <div class="field__label-input-wrap">
                        <label
                            for="cardNumber"
                            class="label"
                        >
                            Card Number
                        </label>
                        <div
                            class="credit-card-number-input-wrap"
                            [class.credit-card-number-input-wrap--populated]="ccType"
                            [class.credit-card-number-input-wrap--amex]="
                ccType === cardTypes.Amex
              "
                            [class.credit-card-number-input-wrap--discover]="
                ccType === cardTypes.Discover
              "
                            [class.credit-card-number-input-wrap--mastercard]="
                ccType === cardTypes.MasterCard
              "
                            [class.credit-card-number-input-wrap--visa]="
                ccType === cardTypes.Visa
              "
                        >
                            <input
                                class="input input--medium"
                                [class.input--invalid]="formErrors.cardNumber"
                                formControlName="cardNumber"
                                id="cardNumber"
                                mask="0000 0000 0000 0000"
                                [dropSpecialCharacters]="true"
                            >
                            <div
                                *ngIf="formErrors.cardNumber"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.cardNumber }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="expirationDate"
                            class="label"
                        >
                            Exp. Date
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.expirationDate"
                            formControlName="expirationDate"
                            id="expirationDate"
                            placeholder="MM/YY"
                            [dropSpecialCharacters]="true"
                            placeholder="MM/YY"
                            mask="00/00"
                        >
                        <div
                            *ngIf="formErrors.expirationDate"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.expirationDate }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="ccv"
                            class="label"
                        >
                            CCV
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.ccv"
                            formControlName="ccv"
                            id="ccv"
                            pattern="[0-9]{3,4}"
                            placeholder="123"                            
                        >
                        <div
                            *ngIf="formErrors.ccv"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.ccv }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="address"
                        class="label"
                    >
                        Address
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.address"
                        id="address"
                        formControlName="address"
                        maxlength="35"
                    >
                    <div
                        *ngIf="formErrors.address"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="city"
                            class="label"
                        >
                            City
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.city"
                            id="city"
                            formControlName="city"
                            maxlength="35"
                        >
                        <div
                            *ngIf="formErrors.city"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.city }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="state"
                            class="label"
                        >
                            State
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.state"
                            id="state"
                            formControlName="state"
                            maxlength="2"
                        >
                        <div
                            *ngIf="formErrors.state"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.state }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="zip"
                            class="label"
                        >
                            Zip&#x2F;Postal Code
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.zip"
                            formControlName="zip"
                            id="zip"
                            mask="00000"
                            [dropSpecialCharacters]="true"
                        >
                        <div
                            *ngIf="formErrors.zip"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.zip }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <ngx-recaptcha2
                        #captchaElem
                        [siteKey]="siteKey"
                        (reset)="handleReset()"
                        (expire)="handleExpire()"
                        (load)="handleLoad()"
                        (success)="handleSuccess($event)"
                        [useGlobalDomain]="false"
                        [size]="size"
                        [hl]="lang"
                        [theme]="theme"
                        [type]="type"
                        formControlName="recaptcha"
                    >
                    </ngx-recaptcha2>
                </div>
            </div>
        </div>
        <p>
            By clicking Submit, I agree to pay
      {{ amount | currency : "USD" : true }} according to the cardholder
      agreement.
        </p>
        <div
            [hidden]="!serverMessage"
            class="error-message field__error-message"
        >
            {{ serverMessage }}
        </div>
        <div class="form-actions form-actions--multi-step">
            <input
                class="button form-actions__item form-actions__item--continue"
                name="submitButton"
                type="submit"
                value="Submit"
            >
            <button
                (click)="onCancel($event)"
                class="button button--secondary form-actions__item form-actions__item--back"
            >
                Cancel
            </button>
        </div>
        <div
            *ngIf="formLevelErrors"
            class="error-message field__error-message"
        >
            <p *ngFor="let error of formLevelErrors">{{ error }}</p>
        </div>
    </fieldset>
</form>
<div *ngIf="paymentSent">
    <p>
        An email with your credential verification will be sent to {{ email }}. If the credential verification email is not recieved within 24 hours or if you have any questions, please contact us at
        <a href="mailto:service@nbrc.org">service@nbrc.org</a>
        or call
        <a href="tel:9138954900">913.895.4900</a>
        .
    </p>
    <p>Thank you for your purchase.</p>
</div>
